//let anchorAttrName = "data-goto-anchor";

export function scrollTo(position, callback) {
  let duration = arguments.length <= 2 || arguments[2] === undefined ? 400 : arguments[2];

  $("body, html").animate({scrollTop: position}, duration, function () {
    if (callback) {
      callback();
    }
  });
}

export function scrollToRecursion(target) {
  //var duration = arguments.length <= 1 || arguments[1] === undefined ? 200 : arguments[1];

  let getPosition = function getPosition() {
    let header = $(".header-inner");
    let correctionPosition = 0;

    if (header.length) {
      correctionPosition = 20 + parseInt(header.outerHeight());
    }

    return parseInt(target.offset().top) - correctionPosition;
  };
  let position = getPosition();

  scrollTo(position, function () {
    let newPosition = getPosition();
    /*an extra scroll cycle (starting an additional iteration recursion) is made specifically to make allowances for lazy loading blocks*/
    if (position != newPosition) {
      scrollToRecursion(target);
    }
  });
}

export function goToAnchor() {
  $(document).ready(function () {
    $("body")/*.on("click", "[" + anchorAttrName + "]", function (e) {
      e.preventDefault();

      var _this = $(this);

      scrollToRecursion($("[data-anchor=" + _this.attr(anchorAttrName) + "]"), 400);
    })*/.on("click", ".anchors a:not(.help-anchor)", function (e) {
      e.preventDefault();

      var _this = $(this);

      _this.closest('li').addClass('active').siblings().removeClass('active');

      scrollToRecursion($("" + _this.attr("href") + ""), 400);
    });
    if($(".anchors-list")){
      let tabsNav = $('.anchors-list');
      let tabIndex = tabsNav.find(".active").index();
      let totalWidth = 0;

      for (let i = 0; i < tabIndex; i++) {
        totalWidth += tabsNav.find('li').eq(i).innerWidth();
      }
      tabsNav.animate({ scrollLeft: totalWidth }, 500);
    }
  });
}

function getUrlHash() {
  var linkArray = window.location.href.split("#");

  return (linkArray[1] == undefined) ? null : linkArray[1];
}

export function scrollToHash() {
  var urlHash = getUrlHash();

  if (urlHash != null) {
    var target = $(document.getElementById(urlHash));

    if (target.length) {
      scrollToRecursion(target);
    }
  }
}


// WEBPACK FOOTER //
// ./assets/js/modules/go-to-anchor.js